import { createSelector } from 'reselect'
import moment from 'moment'

import { PICTURE_DEBUG, PICTURE_TYPES, SERVER_URL } from 'Global/constants'
import { getPicturefilePath } from 'Global/Helpers/rugHelpers'
import { hasPermission } from 'Components/Permissions/utils'
import { isWellShaped } from 'Global/Helpers/objectHelpers'
import { userPermissions as _userPermissions } from 'Components/Permissions/selectors'

export const hasError = state => state.rugDetail.error
export const isPending = state => state.rugDetail.pending
export const pictureError = state => state.rugDetail.pictureError
export const picturePending = state => state.rugDetail.picturePending
export const previewExpanded = state => state.previewModalPicture.expanded
export const previewModalIndex = state => state.previewModalPicture.index
export const previewOpen = state => state.previewModalPicture.visible
export const user = state => state.auth.user

const rug = state => state.rugDetail.rug

export const detailRug = createSelector(
  [rug, _userPermissions],
  (rug, userPermissions) => {
    if (isWellShaped(rug, 'pictures')) {
      return {
        ...rug,
        pictures: rug.pictures.filter(picture => {
          if (picture.primary) {
            return true
          }

          if (picture.report !== null) {
            if (hasPermission('picture.picture.qcPicture', userPermissions)) {
              return true
            } else {
              return false
            }
          }

          if (hasPermission('picture.picture.nonPrimary', userPermissions)) {
            return true
          }

          return false
        }),
      }
    } else {
      return rug
    }
  },
)

export const pictures = createSelector(
  [rug, _userPermissions],
  (rug, userPermissions) => {
    if (isWellShaped(rug, 'pictures')) {
      return rug.pictures
        .filter(picture => {
          if (picture.primary) {
            return true
          }

          if (picture.report !== null) {
            if (hasPermission('picture.picture.qcPicture', userPermissions)) {
              return true
            } else {
              return false
            }
          }

          if (hasPermission('picture.picture.nonPrimary', userPermissions)) {
            return true
          }

          return false
        })
        .sort((a, b) => moment.utc(b.date_scanned).diff(moment.utc(a.date_scanned)))
        .reduce((pictures, picture) => (picture.report ? [...pictures, picture] : [picture, ...pictures]), [])
        .reduce((pictures, picture) => (picture.primary ? [picture, ...pictures] : [...pictures, picture]), [])
    } else {
      return []
    }
  },
)

export const currentPicture = createSelector(
  [pictures, previewModalIndex],
  (pictures, index) => {
    if (index > -1) {
      const picture = pictures[index]

      if (picture) {
        if (PICTURE_DEBUG) {
          return PICTURE_DEBUG
        } else {
          return `${SERVER_URL}${getPicturefilePath(picture, PICTURE_TYPES.C3_BIG)}`
        }
      }
    }

    return ''
  },
)

export const nextPicture = createSelector(
  [rug, previewModalIndex, _userPermissions],
  (rug, index, userPermissions) => {
    if (index > -1) {
      if (isWellShaped(rug, 'pictures')) {
        const pictures = rug.pictures
          .filter(picture => {
            if (picture.primary) {
              return true
            }

            if (picture.report !== null) {
              if (hasPermission('picture.picture.qcPicture', userPermissions)) {
                return true
              } else {
                return false
              }
            }

            if (hasPermission('picture.picture.nonPrimary', userPermissions)) {
              return true
            }

            return false
          })
          .sort(p => !p.primary)
        const picture = pictures[index + 1]

        if (picture) {
          return true
        }
      }
    }

    return false
  },
)

export const previousPicture = createSelector(
  [rug, previewModalIndex, _userPermissions],
  (rug, index, userPermissions) => {
    if (index > -1) {
      if (isWellShaped(rug, 'pictures')) {
        const pictures = rug.pictures
          .filter(picture => {
            if (picture.primary) {
              return true
            }

            if (picture.report !== null) {
              if (hasPermission('picture.picture.qcPicture', userPermissions)) {
                return true
              } else {
                return false
              }
            }

            if (hasPermission('picture.picture.nonPrimary', userPermissions)) {
              return true
            }

            return false
          })
          .sort(p => !p.primary)
        const picture = pictures[index - 1]

        if (picture) {
          return true
        }
      }
    }

    return false
  },
)
